import './InternalDashboard.scss'
import { useRef } from 'react';
import { DatePicker, Button } from 'antd';
import dayjs from 'dayjs';
import {
    BarSeriesModule,
    CategoryAxisModule,
    LegendModule,
    ModuleRegistry,
    NumberAxisModule,
} from 'ag-charts-community';
import { InternalDashboardLogic } from './InternalDashboard';
import AISummary from '../../components/AISummary/AISummary.jsx';
import OfflineTrailersGrid from '../../components/OfflineTrailersGrid/OfflineTrailersGrid.jsx';
import SiteDataGrid from '../../components/SiteDataGrid/SiteDataGrid.jsx';
import SiteModelAccuracyChart from '../../components/SiteModelAccuracyChart/SiteModelAccuracyChart.jsx';

ModuleRegistry.registerModules([
    BarSeriesModule,
    CategoryAxisModule,
    LegendModule,
    NumberAxisModule,
]);

const { RangePicker } = DatePicker;
function Dashboard() {
    const {
        filterDates,
        setFilterDates,
        summaryLoading,
        setSummaryLoading,
        startAndEndUnixDatesParams,
    } = InternalDashboardLogic();

    const aiSummaryRef = useRef(null);

    return (
        <div className='internal-dashboard container-wrapper'>
            <div className='internal-dashboard-row'>
                <RangePicker
                    onChange={(value, timeString) => {
                        setFilterDates({
                            start_date: dayjs(timeString[0]),
                            end_date: dayjs(timeString[1])
                        })
                    }}
                    disabledDate={(current) => current && current < dayjs().subtract(5, 'years').startOf('day')}
                    format={'MM/DD/YYYY'}
                    className='rangeStyle'
                    defaultValue={[dayjs().subtract(30, 'day'), dayjs()]}
                />
                <Button
                    type="primary"
                    onClick={() => aiSummaryRef.current?.triggerFetch()}
                    loading={summaryLoading}
                    style={{ marginBottom: '16px' }}
                >
                    Generate AI Summary
                </Button>
            </div>

            <div className='ai-overview internal-dashboard-row'>
                <AISummary
                    ref={aiSummaryRef}
                    isInternal={true}
                    startAndEndUnixDatesParams={startAndEndUnixDatesParams}
                    onLoadingChange={setSummaryLoading}
                />
            </div>
        
            <div className='internal-dashboard-row'>
                <OfflineTrailersGrid />
            </div>
            
            <div className='internal-dashboard-row'>
                <SiteDataGrid />
            </div>
            
            <div className='internal-dashboard-row'>
                <SiteModelAccuracyChart startAndEndUnixDatesParams={startAndEndUnixDatesParams} />
            </div>
        </div>
    )
}

export default Dashboard